import BgImage from '../../assets/our-dealer/our-dealer-bg.jpg'
import SMAppOurDealer from '../../containers/App-OurDealer'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ScreenWidthPort } from '../../ScreenWidthContext'

export const AppOurDealerScreen: React.FC = () => {
    const { screenWidth } = ScreenWidthPort()
    
    const { t } = useTranslation()

    // ======================= VIEWS
    return (
        <>
            <Box sx={{ position: 'relative', 
                objectFit: 'cover',
                backgroundImage: `url(${BgImage})`,                
                backgroundSize: 'cover',    
                backgroundPosition: 'center',
                width: '100%',
                height: (screenWidth * 226 / 375),
            }}>

                <Box sx={{ position: 'absolute', left: 0, top: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.3)', justifyContent: 'center', alignContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
                    <Typography fontSize={32} fontWeight={700} color={'#FBBF23'} textAlign={'center'}>
                        {t('t386')}
                    </Typography>

                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignContent: 'center', alignItems: 'center', paddingTop: '8px'}}>
                        <Typography fontSize={14} fontWeight={400} color={'#FFFFFF'} textAlign={'center'}>
                            {t('t387')}
                        </Typography>
                        <Box sx={{ width: '1px', height: '20px', backgroundColor: '#FFFFFF', marginLeft: '15px', marginRight: '15px' }}></Box>
                        <Typography fontSize={14} fontWeight={400} color={'#FFFFFF'} textAlign={'center'}>
                            {t('t388')}
                        </Typography>
                    </Box>
                </Box>
            </Box>
            <SMAppOurDealer />
        </>
    )
}

// ======================= EXPORT
export default AppOurDealerScreen
